<template>
    <div class="grid-container">
        <div class="grid-x grid-margin-x">
            <div class="cell">
                <h1 class="underline mb-8">Project Database</h1>
                
                <div>Explore our comprehensive portfolio of sustainable initiatives and strategic consulting projects across Africa and beyond. We are committed to fostering growth in key sectors like Healthcare, Energy, and Agriculture.</div>
                
                <div class="grid-x small-up-2 large-up-4 stat_section">
                    <div class="cell text-center">
                        <div class="stat">{{ filteredOrderedProjects.length }}
                            <small v-if="filteredOrderedProjects.length < projects.length" class="ng-binding ng-scope">&nbsp;/ {{ projects.length }}</small>
                        </div>
                        <p>Project(s)</p>
                    </div>
                    <div class="cell text-center">
                        <div class="stat">{{ averageFunding != "NaN" ? averageFunding : "0.0"  }}</div>
                        <p>Avg. funding <small>(in mio €)</small></p>
                    </div>
                    <div class="cell text-center">
                        <div class="stat">{{ averageDuration != "NaN" ? averageDuration : "00.0" }}</div>
                        <p>Avg. duration <small>(in months)</small></p>
                    </div>
                    <div class="cell text-center">
                        <div class="stat">{{ averagePartners != "NaN" ? averagePartners : "00.0" }}</div>
                        <p>Avg. partners</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-x small-up-1 medium-up-2 large-up-3 form-section">
            <div class="cell">
                <label for="search">Search keywords
                    <input type="text" v-model="search" id="search" placeholder="Search projects..."/>
                </label>
            </div>
            <div class="cell">
                <label for="order">
                    Order
                    <select v-model="order" id="order">
                        <option value="acronym" selected="selected">A-Z</option>
                        <option value="funding">Funding</option>
                        <option value="duration">Duration</option>
                        <option value="partners">Partners</option>
                        <option value="start">Project start</option>
                        <option value="end">Project end</option>
                    </select>
                </label>
            </div>
            <div class="cell">
                <label for="field">
                    Field
                    <select v-model="field" id="field">
                        <option value="any" selected="selected">Any</option>
                        <option value="social" selected="selected">Social Sciences &amp; Humanities</option>
                        <option value="life">Life Sciences, Food &amp; Biotech</option>
                        <option value="ict">ICT, Materials &amp; Engineering Studies</option>
                        <option value="innovation">Innovation Support Actions</option>
                        <option value="other">Other</option>
                    </select>
                </label>
            </div>
            <div class="cell">
                <label for="status">
                    Status
                    <select v-model="status" id="status">
                        <option value="any" selected="selected">Any</option>
                        <option value="active">Active</option>
                        <option value="closed">Closed</option>
                    </select>
                </label>
            </div>
            <div class="cell">
                <label for="sort">
                    Sort
                    <select v-model="sort" id="sort">
                        <option value="asc" selected="selected">Ascending</option>
                        <option value="desc">Descending</option>
                    </select>
                </label>
            </div>
            <div class="cell">
                <label for="funding">
                    Funding
                    <select v-model="funding" id="funding">
                        <option value="any" selected="selected">Any</option>
                        <!-- <option value="horizonEU">Horizon Europe &amp; sub-programmes</option>
                        <option value="horizon">Horizon 2020 &amp; sub-programmes</option>
                        <option value="fp7">FP7</option>
                        <option value="other">Other</option> -->
                    </select>
                </label>
            </div>
        </div>
        <div class="grid-x grid-margin-x small-up-1 medium-up-2 large-up-3">
            <div v-for="project in filteredOrderedProjects" :key="project.title" class="cell">
                <div class="project-card">
                    <div class="image-container">
                        <img :src="project.logoUrl"/>
                    </div>
                    <div class="description-container">
                        <div class="title_status">
                            <div class="title">{{ project.acronym.slice(0, 20) }}</div>
                            <span class="status closed" v-if = "!project.active">Closed</span>
                            <span class="status" v-else>Active</span>
                        </div>
                        <p class="fulltitle">
                            {{ project.fullTitle.slice(0, 115) }}
                        </p>
                        <div>
                            <a class="button primary expanded" :href="project.route">Learn More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>    
    export default {
        data() {
            return {
                projects: [],
                search: '',
                status: 'any',
                order: 'acronym',
                sort: 'asc',
                field: 'any',
                funding: 'any',
                averageFunding: '',
                averageDuration: '',
                averagePartners: '',
            }
        },
        methods: {

        },
        computed: {
            filteredOrderedProjects() {
                const self = this;

                // let filteredOrderedProjects = self.projects;
                let filteredOrderedProjects = self.projects.filter(project => {

                    // Defining if current project is active
                    var end = new Date(project.start);
                    end.setMonth(end.getMonth() + parseInt(project.duration));
                    var now = new Date();
                    project.active = end.getTime() > now.getTime();

                    // Formatting the funding field
                    // project.funding = (project.funding / 1000000);
 
                        
                    // Filtering status
                    if(self.status == 'active' && !project.active)
                        return false
                    if(self.status == 'closed' && project.active)
                        return false
                    
                    // Filtering field
                    if(self.field == 'social' && project.category != "Social Sciences & Humanities")
                        return false
                    if(self.field == 'life' && project.category != "Life Sciences, Food & Biotech")
                        return false
                    if(self.field == 'ict' && project.category != "ICT, Materials & Engineering Studies")
                        return false
                    if(self.field == 'innovation' && project.category != "Innovation Support Actions")
                        return false
                    if(self.field == 'other' && project.category != "Other")
                        return false
                    
                    // Filtering funding
                    // if(self.funding == 'horizonEU' && project.programme != "Horizon Europe & sub-programmes")
                    //     return false
                    // if(self.funding == 'horizon' && project.programme != "Horizon 2020 & sub-programmes")
                    //     return false
                    // if(self.funding == 'fp7' && project.programme != "FP7")
                    //     return false
                    // if(self.funding == 'other' && project.programme != "Other")
                    //     return false

                    let searchRegex = new RegExp(self.search, 'i')

                    for(let prop in project) {
                        if(searchRegex.test(project[prop]))
                            return true
                    }
                });

                // Ordering filtered projects
                filteredOrderedProjects = filteredOrderedProjects.sort((project1, project2) => {
                    var a1 = "";
                    var a2 = "";

                    if(self.order == "acronym") {
                        a1 = project1[self.order].toLowerCase();
                        a2 = project2[self.order].toLowerCase();
                    } else if (self.order == "funding" || self.order == "duration" || self.order == "partners") {
                        a1 = parseFloat(project1[self.order]);
                        a2 = parseFloat(project2[self.order]);
                    } else {
                        a1 = new Date(project1[self.order]);
                        a2 = new Date(project2[self.order]);
                    }

                    if (self.sort == "asc")
                        return a1 > a2 ? 1 : -1;
                    else 
                        return a1 > a2 ? -1 : 1;
                });

                // Calculating the statistics
                self.averageFunding = (filteredOrderedProjects.reduce((start, current) => start + parseFloat(current.funding), 0) / filteredOrderedProjects.length).toFixed(1);
                self.averageDuration = (filteredOrderedProjects.reduce((start, current) => start + parseFloat(current.duration), 0) / filteredOrderedProjects.length).toFixed(1);
                self.averagePartners = (filteredOrderedProjects.reduce((start, current) => start + parseFloat(current.partners), 0) / filteredOrderedProjects.length).toFixed(1);

                return filteredOrderedProjects;
            }
        },
        mounted() {
            this.projects = projects
        }
    }
</script>